import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const PromiseNeverForgetPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/hidkZE7pnuDdsYunj1wZ11/Madeleine_Morlet_1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mx8mrAg4PHAY8mQEmm1fqb/Madeleine_Morlet_2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mP3BR1QUjfT2XqWiEGYhbb/Madeleine_Morlet_3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/fuL5gRuHQ6o4ukBGcyeC4x/Madeleine_Morlet_4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/iTtKjejxZ8gXbq4c2FSZDc/Madeleine_Morlet_5.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6Gw9GwWqKXSMUoiuLiFzi8/Madeleine_Morlet_6.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/w2VR4kTDevX9g4VWqy75cY/Madeleine_Morlet_7.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/oboqfQeRz1hrKyvhiJ8C2t/Madeleine_Morlet_8.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/54NunmgGGBiT8H5jXwbosk/Madeleine_Morlet_9.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/aUjM2G1g7uzGowzRyS6nmq/Madeleine_Morlet_10.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/aJDX9cCHFCPgTU3JmVdVqj/Madeleine_Morlet_11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/uUcoSxgZY8LMAxMVvaqcR7/Madeleine_Morlet_12.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/49QaNiepi3zdsNCNwcz7AM/Madeleine_Morlet_13.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5Lqa4Z1P5dbFyqwaLqC6W2/Madeleine_Morlet_14.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dzhUR5M9ixAH3psDyVQZED/Madeleine_Morlet_15.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/nUgYCnjqQwCb1u5uadst5D/Madeleine_Morlet_16.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hvPcgBknPXsC96AV7a7QYT/Madeleine_Morlet_17.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4iRJuQPRsahAM41iH1xc5k/Madeleine_Morlet_18.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4hm8HENkSXGA4FzLB1XQhG/Madeleine_Morlet_19.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/8qWuSgCSu69DPRJH7a1YxW/Madeleine_Morlet_20.jpg'];
  // Create a varied spacing array to make the layout more editorial
  const getSpacing = index => {
    const spacings = [6, 12, 8, 16, 10, 14, 7, 12, 9, 16, 10, 14];
    return spacings[index % spacings.length];
  };
  // Create a varied height array for more visual interest
  const getImagePosition = (index: number) => {
    if (index === 0) return '16vh';
    const positions = ['24vh', '8vh', '20vh', '4vh', '28vh', '12vh', '16vh'];
    return positions[index % positions.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh';
    const sizes = ['75vh', '65vh', '80vh', '70vh', '85vh'];
    return sizes[index % sizes.length];
  };
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-451">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-452">
        <div className="flex space-x-6" data-id="element-453">
          <div className="text-base font-normal" data-id="element-454">
            <Link to="/" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-455">
              Madeleine Morlet
            </Link>
          </div>
          <div className="text-base font-normal" data-id="element-456">
            <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-457">
              Info
            </Link>
          </div>
        </div>
      </header>
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-458">
        <div className="flex min-w-max" data-id="element-459">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '24vh'
        }} data-id="element-460">
            <div className="text-base max-w-[360px] pr-4" data-id="element-461">
              <div data-id="element-462">I Promise I'll Never Forget (2018 to 2021)</div>
              <div className="text-sm leading-normal mt-4" data-id="element-463">
                <em data-id="element-464">I Promise I'll Never Forget</em> is a love letter to youth.
                This dramatisation of adolescence serves to examine identity and
                personal relationships through the construction of imaginative
                narratives. These images have been made in mid-coast Maine,
                reflecting on how our uncertain and self-conscious times are not
                met alone, but amongst our communities. They hold a mirror to my
                own coming of age, as a foreigner and new mother, experiences
                that have been punctuated by a youthful ambition for friendship
                and concurrent feelings of isolation. How daring it is to make
                such extravagant promises, knowing that memories are as fleeting
                as life itself.
              </div>
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-465">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-466">
                <img src={image} alt={`I Promise I'll Never Forget - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-467" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-468">
        <div className="mb-6" data-id="element-469">
          <div className="text-base mb-4" data-id="element-470">
            I Promise I'll Never Forget (2018 to 2021)
          </div>
          <div className="text-sm leading-normal" data-id="element-471">
            <em data-id="element-472">I Promise I'll Never Forget</em> is a love letter to youth. This
            dramatisation of adolescence serves to examine identity and personal
            relationships through the construction of imaginative narratives.
            These images have been made in mid-coast Maine, reflecting on how
            our uncertain and self-conscious times are not met alone, but
            amongst our communities. They hold a mirror to my own coming of age,
            as a foreigner and new mother, experiences that have been punctuated
            by a youthful ambition for friendship and concurrent feelings of
            isolation. How daring it is to make such extravagant promises,
            knowing that memories are as fleeting as life itself.
          </div>
        </div>
        <div className="w-full space-y-8" data-id="element-473">
          {images.map((image, index) => <div key={index} className="w-full" data-id="element-474">
              <img src={image} alt={`I Promise I'll Never Forget - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-475" />
            </div>)}
        </div>
      </div>
      <ScrollIndicator data-id="element-476" />
      <style jsx data-id="element-477">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default PromiseNeverForgetPage;